/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VehicleRentalReservation } from './VehicleRentalReservation';
import {
    VehicleRentalReservationFromJSON,
    VehicleRentalReservationFromJSONTyped,
    VehicleRentalReservationToJSON,
    VehicleRentalReservationToJSONTyped,
} from './VehicleRentalReservation';

/**
 * 
 * @export
 * @interface ItineraryVehicles
 */
export interface ItineraryVehicles {
    /**
     * 
     * @type {Array<VehicleRentalReservation>}
     * @memberof ItineraryVehicles
     */
    items?: Array<VehicleRentalReservation>;
}

/**
 * Check if a given object implements the ItineraryVehicles interface.
 */
export function instanceOfItineraryVehicles(value: object): value is ItineraryVehicles {
    return true;
}

export function ItineraryVehiclesFromJSON(json: any): ItineraryVehicles {
    return ItineraryVehiclesFromJSONTyped(json, false);
}

export function ItineraryVehiclesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ItineraryVehicles {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(VehicleRentalReservationFromJSON)),
    };
}

export function ItineraryVehiclesToJSON(json: any): ItineraryVehicles {
    return ItineraryVehiclesToJSONTyped(json, false);
}

export function ItineraryVehiclesToJSONTyped(value?: ItineraryVehicles | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(VehicleRentalReservationToJSON)),
    };
}

